import React from "react";
import Typing from "react-typing-animation";
import Scrollchor from "react-scrollchor";
export default () => (
  <section id="banner">
    <div className="content">
      <header>
        <h2 style={{ textAlign: "right", lineHeight: "80px" }}>
          <span style={{ color: "#0093ff" }}>I</span> spire
        </h2>

        {/*  Heading */}
        <Typing>
          <h1 style={{ fontSize: "3em", lineHeight: "50px" }}>
            {" "}
            <span style={{ color: "#0093ff" }}>Isaac</span> Browne
          </h1>
        </Typing>

        <Typing startDelay={1000} speed={"50ms"}>
          <p style={{ textAlign: "right", marginTop: "-2em" }}>
            Full-Stack Developer Innovation by default.
            <br /> empowerment by design.
          </p>
        </Typing>
      </header>
      <span className="image" style={{ width: "100px", height: "100px" }}>
        <img
          src="http://www.araboverclockers.net/wp-content/uploads/2016/04/ZUK_Z2Pro_art-316x316.jpg"
          alt="image"
        />
      </span>
    </div>
    <Scrollchor
        to={"#projects"}
        className={"goto-next"}
         animate={{offset: 20, duration: 600}}
        >
      Next
    </Scrollchor>
  </section>
);

const styles = {
  header: {
    fontSize: "2em"
  }
};
